<div class="liquidaciones-page">
    <router-outlet></router-outlet>
</div> 